<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать консьержа</strong>
                </CCardHeader>
                <CCardBody>
                    <ConciergeUpsertForm
                        @success="$router.push(`/concierges`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import ConciergeUpsertForm from '@/components/concierges/ConciergeUpsertForm';

    export default {
        name: 'ConciergeCreate',

        components: {
            ConciergeUpsertForm
        },
    };
</script>
